import type { EventReminder } from 'models';
import { createEventReminder } from 'models';
import { queryClient, useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services/api';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getCalendarPrincipalEventsListQueryKey } from 'features/calendar/queries';
import { deleteEvent } from '../../services';
import { getNodeEventDetailQueryKey, getNodeEventsQueryKey } from '../keys';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. The event couldn’t be deleted.');
};

export const useDeleteEvent = () =>
  useMutation<EventReminder, { id: string }>({
    defaultMutateOnError,
    async mutationFn({ id }) {
      const { data } = await deleteEvent({ routeParams: { id } });

      return createEventReminder(data);
    },
    async onSuccess(_, { id }) {
      await queryClient.invalidateQueries({ queryKey: getNodeEventsQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getCalendarPrincipalEventsListQueryKey({}) });
      queryClient.removeQueries({ queryKey: getNodeEventDetailQueryKey({ eventId: id }) });
    },
  });
